import { Skeleton } from "@/components/ui/skeleton";

/** Generic content skeleton while a route chunk loads. */
export function PageSkeleton() {
  return (
    <div className="container-shell space-y-6 py-8" aria-busy="true">
      <div className="space-y-2">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-9 w-64" />
      </div>
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {[0, 1, 2].map((i) => (
          <Skeleton key={i} className="h-56 rounded-card" />
        ))}
      </div>
    </div>
  );
}
